// File: webelieve-frontend/src/features/admin/components/settings/workflow-builder/WorkflowPanel.tsx
// EF-7E: Top-level panel managing list and builder modes

import React, { useState, useCallback } from 'react';
import WorkflowList from './WorkflowList';
import WorkflowBuilder from './WorkflowBuilder';

type PanelMode = 'list' | 'builder';

const WorkflowPanel: React.FC = () => {
  const [mode, setMode] = useState<PanelMode>('list');
  const [selectedWorkflowId, setSelectedWorkflowId] = useState<string | null>(null);

  const handleEdit = useCallback((workflowId: string) => {
    setSelectedWorkflowId(workflowId);
    setMode('builder');
  }, []);

  const handleCreate = useCallback(() => {
    setSelectedWorkflowId(null);
    setMode('builder');
  }, []);

  const handleSave = useCallback(() => {
    setMode('list');
    setSelectedWorkflowId(null);
  }, []);

  const handleCancel = useCallback(() => {
    setMode('list');
    setSelectedWorkflowId(null);
  }, []);

  if (mode === 'builder') {
    return (
      <WorkflowBuilder
        workflowId={selectedWorkflowId}
        onSave={handleSave}
        onCancel={handleCancel}
      />
    );
  }

  return <WorkflowList onEdit={handleEdit} onCreate={handleCreate} />;
};

export default WorkflowPanel;
